import Axios from "axios";
import { environment } from "../environments/env";
import router from "../router/index";
const API = Axios.create({ baseURL: environment.apiUri });

API.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");

    try {
      if (token) {
        config.headers.Authorization = `Bearer ${token.replace(/["]/g, "")}`;
      }

      return config;
    } catch (error) {
      console.debug(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 204
    ) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    let response = error.response;
    if (response && error.response.status) {
      switch (error.response.status) {
        case 400:
          console.log("400");
          break;
        case 403:
          console.log("403");
          break;
        case 401:
          console.log("401");
          return router.push({ name: "Login" });
        case 500:
          console.log("500");
      }
    }
    return Promise.reject(error.response);
  }
);
export default API;
